import * as constant from "./constant";

const INITIAL_STATE = {
  loading: false,
  signinResponse: {
    data: {
      email: null,
      greet: null,
      message: null,
      token: null,
      username: null,
    },
    httpStatus: 0,
  },
  signupResponse: {
    data: null,
    httpStatus: 0,
  },
  forgotResponse: {
    data: null,
    httpStatus: 0,
  },
  resetResponse: {
    data: null,
    httpStatus: 0,
  },
  refreshResponse: {
    data: {
      email: null,
      message: null,
      token: null,
      username: null,
    },
    httpStatus: 0,
  },
  resendResponse: {
    data: null,
    httpStatus: 0,
  },
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constant.LOADING:
      return Object.assign({}, state, {
        loading: action.payload,
      });
    case constant.SIGNIN_RESPONSE:
      return Object.assign({}, state, {
        signinResponse: action.payload,
      });
    case constant.SIGNUP_RESPONSE:
      return Object.assign({}, state, {
        signupResponse: action.payload,
      });
    case constant.FORGOT_RESPONSE:
      return Object.assign({}, state, {
        forgotResponse: action.payload,
      });
    case constant.RESET_RESPONSE:
      return Object.assign({}, state, {
        resetResponse: action.payload,
      });
    case constant.REFRESH_RESPONSE:
      return Object.assign({}, state, {
        refreshResponse: action.payload,
      });
    case constant.RESEND_RESPONSE:
      return Object.assign({}, state, {
        resendResponse: action.payload,
      });
    default:
      return state;
  }
};

export default authReducer;
